"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.asynchronousMapDataToObject = void 0;
const Nodes_1 = require("./Nodes");
const Cache_1 = __importDefault(require("./Cache"));
const lodash_1 = __importDefault(require("lodash"));
const MapScenarios_1 = require("./MapScenarios");
//Functions to handle item iteration - currently should only be called from async, but both async and sync can use the same functions if needed later on.
const handleObject = (obj, oldNodeId, addition, originalNodeId, path, nodeMap, localMapDefinition, og, cachedResolver) => {
    Object.keys(obj).forEach(i => {
        //For each key of the object in question
        const inp = obj[i];
        if (inp && inp.sourceObject && inp.sourcePath) {
            //If this value has sourceObject and sourcePath, it is referencing an input value
            if (inp.sourceObject === oldNodeId) {
                //Check source object to see if it is referencing our oldNodeId
                localMapDefinition.nodes[originalNodeId + addition] = //If so, create a new node if relevant
                    localMapDefinition.nodes[originalNodeId + addition] || lodash_1.default.cloneDeep(localMapDefinition.nodes[originalNodeId]); //If it already exists, keep it. Otherwise do a deep clone of the original - this is to prevent changes made to the clone from affecting the original
                const newInp = lodash_1.default.get(localMapDefinition.nodes[originalNodeId + addition], path + '.' + i); //Get the input object that we want to change
                newInp.sourceObject = oldNodeId + addition; //Update source object to the new node value
                nodeMap[originalNodeId + addition] = cachedResolver; //Set nodemap for the new node
                addNewNode(originalNodeId, addition, nodeMap, localMapDefinition, og, cachedResolver); //Update all nodes downstream of the updated node
            }
        }
        else if (typeof inp === 'object' && inp !== null) {
            //If the value is an object, but not an input reference, recursively call this to handle any inputs within the object
            handleObject(inp, oldNodeId, addition, originalNodeId, path + '.' + i, nodeMap, localMapDefinition, og, cachedResolver);
        }
    });
};
const addNewNode = (oldNodeId, addition, nodeMap, localMapDefinition, ogMapDefinition, cachedResolver) => {
    Object.keys(ogMapDefinition.nodes).forEach(originalNodeId => {
        if (localMapDefinition.nodes[originalNodeId].inputs) {
            //For each node that has inputs, check each input value for the oldNodeId and make copies if it is found
            handleObject(localMapDefinition.nodes[originalNodeId].inputs, oldNodeId, addition, originalNodeId, 'inputs', nodeMap, localMapDefinition, ogMapDefinition, cachedResolver);
        }
    });
};
const iterateValues = (arr, nodeId, addToCache, nodeMap, localMapDefinition, cachedResolver) => {
    const og = lodash_1.default.cloneDeep(localMapDefinition);
    arr.forEach((item, index) => {
        //For each value...
        if (index > 0) {
            //Other than the first one...
            nodeMap[`${nodeId}-iteration-${nodeId}-${index}`] = cachedResolver; //Add to nodemap
            addToCache(`${nodeId}-iteration-${nodeId}-${index}`, item); //Assign value to cache so it can be resolved correctly later...
            addNewNode(nodeId, `-iteration-${nodeId}-${index}`, nodeMap, localMapDefinition, og, cachedResolver); //And add copies of all nodes downstream of the affected node
        }
    });
    return arr[0]; //Return first item so it can be used as the value for non-duplicated nodes.
};
const asynchronousMapDataToObject = async (mapDefinition, accessors, configFunctions, timestamp, parentNodeId) => {
    //build an empty cache mapping node ids to the objects they return
    const localMapDefinition = lodash_1.default.cloneDeep(mapDefinition);
    const cache = new Cache_1.default();
    const nodes = localMapDefinition.nodes ? localMapDefinition.nodes : {};
    //build the nodeMap used to resolve the values of nodes
    const nodeMap = {};
    const addToCache = (name, value) => {
        cache.addValue(name, value);
    };
    const cachedResolver = (nodeMap, nodeId) => {
        const cacheValue = cache.getValue(nodeId);
        if (cacheValue) {
            return Promise.resolve(cacheValue);
        }
        else {
            const nodeDefinition = localMapDefinition.nodes[nodeId];
            //This resolver implementation is mostly here to work around typesccript class instantiation
            const resolver = async (nodeClass) => {
                const nodeInstance = new nodeClass(Object.assign(Object.assign({}, nodeDefinition), { accessorMap: accessors, mapScenarios: MapScenarios_1.mapScenarios }));
                const nodeIds = parentNodeId ? `${parentNodeId}-${nodeId}` : nodeId;
                const valuePromise = nodeInstance.asynchronousResolver(nodeMap, configFunctions, {
                    parentNodeId: nodeIds,
                    timestamp: timestamp,
                    seed: timestamp ? `${nodeIds}-${timestamp.toISOString()}` : null,
                });
                let value = await valuePromise;
                //recursively add new nodes if the node is set to iterate its values.
                if (nodeInstance.iterate && Array.isArray(value.output)) {
                    value = iterateValues(value.output, nodeId, addToCache, nodeMap, localMapDefinition, cachedResolver);
                }
                if (value !== null) {
                    return value;
                }
            };
            const NodeClass = Nodes_1.AllNodeMap[nodeDefinition.type];
            const r = resolver(NodeClass);
            cache.addValue(nodeId, r);
            return r;
        }
    };
    Object.keys(nodes).forEach(nId => {
        nodeMap[nId] = cachedResolver;
    });
    const outputDef = localMapDefinition.outputDefinition;
    if (!outputDef) {
        //This should never be reached, but a bad config could cause this
        return {};
    }
    if (outputDef && outputDef.outputNode) {
        const outNode = nodeMap[outputDef.outputNode];
        return outNode ? outNode(nodeMap, outputDef.outputNode) : {};
    }
    else {
        const outputQuery = outputDef.outputQuery;
        const allNodeIds = Object.keys(nodes);
        const nodeIds = allNodeIds.filter(nodeId => {
            var _a, _b;
            return (outputDef.outputNodes && outputDef.outputNodes.includes(nodeId)) ||
                (outputQuery && ((_a = outputQuery.nodeIds) === null || _a === void 0 ? void 0 : _a.includes(nodeId))) ||
                (outputQuery && ((_b = outputQuery.types) === null || _b === void 0 ? void 0 : _b.includes(localMapDefinition.nodes[nodeId].type)));
        });
        let promises = new Array();
        const keys = new Array();
        //Delete after 5.4.12
        //   const resolveNode = async (id: string): Promise<Record<string, unknown>> => {
        //     const ret = { [id]: await nodeMap[id](nodeMap, id) };
        //       Object.keys(nodeMap).forEach(key => {
        //         //This will find any output nodes that were duplicated
        //         if (key.match(id + '-iteration')) {
        //           keys.push(key);
        //         }
        //       });
        //     return ret;
        //   };
        const allKeys = nodeIds;
        let previousCount = Object.keys(nodeMap).length;
        let more = false;
        const resolveNode = async (id) => {
            const ret = { [id]: await nodeMap[id](nodeMap, id) };
            if (Object.keys(nodeMap).length !== previousCount || more) {
                more = false;
                Object.keys(nodeMap).forEach(key => {
                    //This will find any output nodes that were duplicated
                    if (key.match(id + '-iteration')) {
                        keys.push(key);
                        allKeys.push(key);
                    }
                    else if (!more &&
                        !allKeys.filter(k => k === key).length &&
                        allKeys.filter(k => key.match(k + '-iteration')).length) {
                        more = true;
                    }
                });
                previousCount = Object.keys(nodeMap).length;
            }
            return ret;
        };
        promises = nodeIds.map(async (nodeId) => {
            // get the value of the current output node
            return resolveNode(nodeId);
        }, {});
        const resolvePromises = async () => {
            if (keys.length) {
                const keysToProcess = keys.splice(0, Math.min(keys.length, 100));
                promises = promises.concat(
                //Add all of the duplicated keys to the list of promises
                keysToProcess.map(async (nodeId) => {
                    // get the value of the current output node
                    return await resolveNode(nodeId);
                }, {}));
            }
            //Using this to resolve promises because we have the ability to add on to them in the process of resolving
            return Promise.all(promises).then(resolved => {
                if (keys.length) {
                    // The list of promises or values changed. Return a new Promise.
                    // The original promise won't resolve until the new one does.
                    return resolvePromises();
                }
                // The list of promises or values stayed the same.
                // Return results immediately.
                return resolved;
            });
        };
        return resolvePromises().then(values => {
            return values.reduce((acc, value) => {
                return Object.assign(Object.assign({}, acc), value);
            }, {});
        });
    }
};
exports.asynchronousMapDataToObject = asynchronousMapDataToObject;
//# sourceMappingURL=MapExecutor.js.map